import { arrowUpShortcut } from './arrow-up';

export const arrowLeftShortcut = {
  key: new Set(['ArrowLeft']),
  callBackFunction: () => {
    arrowUpShortcut.callBackFunction();
  },
};
